// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1573":"e98607b114434d6f","5322":"80720ad90370b248","6972":"5c72837ffd79a769"}[chunkId] + ".js";
};